// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"c2bc4713","453":"a9475465","997":"d52fbbe0"}[chunkId] + ".chunk.js";
};